// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import core from '@bmp-vue/core'

const controllers = require.context(
  '@/controllers', true, /\.js$/
)
core.methods.init(controllers)

function isApiLoaded () {
  setTimeout(function () {
    if (core.store.getters.loading || core.store.getters.activeRequests > 0) {
      isApiLoaded()
      return false
    }

    const theme = require('@/plugins/vuetify/theme').default
    const paths = require('@/plugins/router/paths').default
    const App = () => import('./App')
    core.methods.finish(paths, theme, App)
  }, 100)
}

isApiLoaded()
